







































export default
  props: {
    close_color:
      type: String
      default: ''
    show_suu:
      type: Boolean
      default: false
    is_suu:
      type: Boolean
      default: false
    point:
      type: Number
      default: 0
    mode:
      type: String
      default: ''
    background_color:
      type: Number
      default: -1
    first_title:
      type: String
      default: ''
    second_title:
      type: String
      default: ''
    point_image:
      type: String
      default: ''
    image_number:
      type: Number
      default: 0
    quiz_result:
      type: Number
      default: 0
    episode_mode:
      type: Boolean
      default: false
  }
  mounted: () ->
    document.querySelector('html, body').style.overflowY = 'hidden'
    document.querySelector('.scroll_area').addEventListener('scroll', @scroll)
    document.querySelector('#section_flow').style.display = 'none'
  beforeDestroy: () ->
    document.querySelector('#section_flow').style.display = 'block'
    document.querySelector('html, body').style.overflowY = 'scroll'
    if window.innerWidth > 750
      document.querySelector('#section_flow').style.display = 'flex'

  methods: {
    popup_close: (e) ->
      @$emit('closePopup')
    scroll: (e) ->
      pos = document.querySelector('.scroll_area').scrollTop + document.querySelector('.scroll_area').offsetHeight
      if pos + 10 >= document.querySelector('.scroll_gimic').offsetHeight
        @popup_close(e)
  }
